import React ,{useEffect} from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Cours from '../../Utilitis/Course/Cours'
import Section from '../../Utilitis/Section'
import SingalHeader from '../../Utilitis/SingalHeader'


export default function Courses() {
    useEffect(() => {
        window.scrollTo(0, 0);
      return () => {
        }
      }, []);
    return (
        <>
            <SingalHeader title="Our Cousers" />
            <Section bg="white" bg_Img={"/images/courses_background.jpg"}>
                <Container>
                    <Row>
                    <Col lg={4} md={6} sm={12} xs={12}>  <Cours name="1" title="Artificial intelligence Course" image="/images/course01.jpg"/> </Col>
                    <Col lg={4} md={6} sm={12} xs={12}>  <Cours name="2" title="How to Get Started in Photography" image="/images/course02.jpg"/> </Col>
                    <Col lg={4} md={6} sm={12} xs={12}>  <Cours name="3" title="Introduction to CSS " image="/images/course01.jpg"/> </Col>
                    <Col lg={4} md={6} sm={12} xs={12}>  <Cours name="3" title="Introduction to CSS " image="/images/course04.jpg"/> </Col>
                    <Col lg={4} md={6} sm={12} xs={12}>  <Cours name="3" title="Introduction to CSS " image="/images/course05.jpg"/> </Col>
                    <Col lg={4} md={6} sm={12} xs={12}>  <Cours name="3" title="Introduction to CSS " image="/images/course06.jpg"/> </Col>
                    </Row>
                </Container>
            </Section>
        </>
    )
}
